import React from 'react';
import { useAuth } from 'oidc-react';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from '@mui/material/CircularProgress';

export default function AuthGuard({ children }) {
    const auth = useAuth();

    if (!auth?.userData) {
        return (
            <Backdrop sx={(theme) => ({ color: '#00000', zIndex: theme.zIndex.drawer + 1 })} open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    return children;
}